// @flow

import React, { type ElementProps } from "react";
import { Text, View } from "@components";

import type {
  ObjectFieldTemplatePropertyType,
  ObjectFieldTemplateProps,
  canExpand,
  descriptionId,
  titleId,
} from "@rjsf/utils";

/** The `ObjectFieldTemplate` is the template to use to render all the inner properties of an object along with the
 * title and description if available. If the object is expandable, then an `AddButton` is also rendered after all
 * the properties.
 *
 * @param props - The `ObjectFieldTemplateProps` for this component
 */
export default function ObjectFieldTemplate(props: ObjectFieldTemplateProps) {
  const { idSchema, onAddClick, properties, schema, uiSchema, title } = props;
  const uiOptions = (uiSchema && uiSchema["ui:options"]) || {};
  const isBoxGrid = uiOptions.boxGrid || uiSchema.boxGrid;

  const columnsCnt = uiOptions.columns;
  const gridColsAndRows = uiOptions && {
    rowStart: uiOptions.rowStart,
    colStart: uiOptions.colStart,
    rowEnd: uiOptions.rowEnd,
    colEnd: uiOptions.colEnd,
  };

  const header = (uiSchema && uiSchema["ui:header"]) || null;
  return (
    <View
      id={idSchema.$id}
      name="object-field-template"
      flex={1}
      gridTemplateColumns={columnsCnt}
      {...gridColsAndRows}
    >
      {header && <Text type="h4" text={header} />}
      {properties.map((prop: ObjectFieldTemplatePropertyType) => ({
        ...prop.content,
        props: {
          ...prop.content.props,
          uiSchema: {
            ...prop.content.props.uiSchema,
            // transfer a global uiSchema property (layoutFlexRatio)
            // that way every field will have access to the width ration between label and field template
            ["ui:layoutFlexRatio"]: uiSchema["ui:layoutFlexRatio"],
            boxGrid: isBoxGrid,
          },
        },
      }))}
    </View>
  );
}
